import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  public isIIKOSyncing = false;

  constructor(private mApiService: ApiService, private mMessageService: MessageService) { }

  ngOnInit(): void {
  }

  public syncIIKO() {
    this.isIIKOSyncing = true;
    this.mApiService.post('/api/admin/catalog/iiko/sync', {}).subscribe({
      next: () => {
        this.isIIKOSyncing = false;
        this.mMessageService.addMessage({ text: 'Синхронизация завершена', type: this.mMessageService.types.success });
      },
      error: () => this.isIIKOSyncing = false
    });
  }

}
